import { render } from "./MMAdminMembership.vue?vue&type=template&id=056ee364"
import script from "./MMAdminMembership.vue?vue&type=script&lang=js"
export * from "./MMAdminMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__